const {AI_BUILDER_MAX_SOURCE_CHARS} = require('./protocol')

function stylePattern() {
  return /<style\b[^>]*>([\s\S]*?)<\/style>/gi
}

function scriptPattern() {
  return /<script\b([^>]*)>([\s\S]*?)<\/script>/gi
}

function scriptSrcPattern() {
  return /<script\b[^>]*\bsrc\s*=[^>]*>[\s\S]*?<\/script>/gi
}

function linkPattern() {
  return /<link\b[^>]*>/gi
}

function takeDocumentParts(source) {
  const headMatch = source.match(/<head\b[^>]*>([\s\S]*?)<\/head>/i)
  const bodyMatch = source.match(/<body\b[^>]*>([\s\S]*?)<\/body>/i)
  const looksFull = /<!doctype/i.test(source) || /<html[\s>]/i.test(source) || Boolean(headMatch && bodyMatch)
  if (!looksFull || !bodyMatch) return {fragment: source, headHtml: ''}
  return {fragment: bodyMatch[1], headHtml: headMatch ? headMatch[1] : ''}
}

function collectHead(headHtml, warnings) {
  const css = []
  const links = []
  const js = []
  if (!headHtml) return {css, links, js}
  const withoutSrc = headHtml.replace(scriptSrcPattern(), function () {
    warnings.push('external-script-removed')
    return ''
  })
  const withoutStyle = withoutSrc.replace(stylePattern(), function (_, cssText) {
    css.push(String(cssText).trim())
    return ''
  })
  withoutStyle.replace(linkPattern(), function (tag) {
    if (/stylesheet/i.test(tag)) links.push(tag)
    return tag
  })
  withoutStyle.replace(scriptPattern(), function (_, attrs, code) {
    if (/\bsrc\s*=/i.test(String(attrs || ''))) {
      warnings.push('external-script-removed')
      return ''
    }
    if (/\btype\s*=\s*["']module["']/i.test(String(attrs || ''))) warnings.push('module-script-kept')
    js.push(String(code).trim())
    return ''
  })
  return {css, links, js}
}

function splitSectionHtml(source) {
  if (typeof source !== 'string') return {ok: false, reason: 'invalid-payload', warnings: []}
  const trimmed = source.trim()
  if (!trimmed) return {ok: false, reason: 'empty-html', warnings: []}
  if (trimmed.length > AI_BUILDER_MAX_SOURCE_CHARS) return {ok: false, reason: 'too-large', warnings: []}

  const warnings = []
  const parts = takeDocumentParts(trimmed)
  const head = collectHead(parts.headHtml, warnings)
  let fragment = parts.fragment.replace(scriptSrcPattern(), function () {
    warnings.push('external-script-removed')
    return ''
  })
  const cssParts = head.css.slice()
  fragment = fragment.replace(stylePattern(), function (_, cssText) {
    cssParts.push(String(cssText).trim())
    return ''
  })
  const jsParts = head.js.slice()
  fragment = fragment.replace(scriptPattern(), function (_, attrs, code) {
    const attrText = String(attrs || '')
    if (/\bsrc\s*=/i.test(attrText)) {
      warnings.push('external-script-removed')
      return ''
    }
    if (/\btype\s*=\s*["']module["']/i.test(attrText)) warnings.push('module-script-kept')
    jsParts.push(String(code).trim())
    return ''
  })

  const markup = fragment.trim()
  if (!markup) return {ok: false, reason: 'empty-html', warnings}
  const html = head.links.length ? head.links.join('\n') + '\n' + markup : markup
  return {
    ok: true,
    html,
    css: cssParts.filter(Boolean).join('\n\n'),
    js: jsParts.filter(Boolean).join('\n\n'),
    warnings,
  }
}

module.exports = {splitSectionHtml}
